<ng-container [ngSwitch]="remoteConfigStore.typeOfBookingPackage$ | async">
  <app-commercial-booking
    *ngSwitchCase="BookingSubscriptionPackageOptions.Commercial"
  ></app-commercial-booking>
  <app-flat-booking *ngSwitchCase="BookingSubscriptionPackageOptions.FlatRate"></app-flat-booking>
  <app-booking-voucher
    *ngSwitchCase="BookingSubscriptionPackageOptions.UserUsaCanada"
  ></app-booking-voucher>
  <ng-container *ngSwitchDefault>
    <!-- Contigent -->
    <app-booking-contingent-subscriptions
      *ngIf="invoiceNumber && isHardwareBundlingAvailable; else booking"
      [invoiceNumber]="invoiceNumber"
    ></app-booking-contingent-subscriptions>
    <ng-template #booking>
      <!-- Standard booking per installation -->
      <app-booking></app-booking>
    </ng-template>
  </ng-container>
</ng-container>
